<style lang="scss" scope>
.toolbar {
  @include border-bottom();
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>
<template>
    <el-card shadow="never" 
    class="l-main-card"
    v-loading="loading_export"
    element-loading-text="拼命导出中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="l-container-sider">
            <l-applet-org-list @on-before-check="loading = true" @on-after-check="aftercheckOrg"></l-applet-org-list>
        </div>
        
        <!--右边菜单列表-->
        <div class="l-container-content" v-loading="loading">
          <!-- <div class="l-menu-box"> -->
            <!-- <div class="l-container-title"><i class="el-icon-user-solid" /><b>消防柜管理</b>
            </div> -->
            <!-- <div class="l-menu-list-main" style="bottom: 0; top: 30px"> -->
            <div class="l-table-toolbar">
                <l-auth-button class="ivu-mr" style="text-align: right" type="primary" auth="cabinet_list_export_btn" @click="handleExport()"> 导出数字台账 </l-auth-button>
                <el-dropdown class="ivu-mr" @command="command">
                  <el-button type="info">
                    <i class="el-icon-arrow-down el-icon--right"></i> 导出台账(excel)
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">
                      <l-auth-text-button auth="cabinet_export_inspect_btn">导出培训完成情况</l-auth-text-button>
                    </el-dropdown-item>
                    <el-dropdown-item :command="2">
                      <l-auth-text-button auth="cabinet_export_other_btn">导出登录台账</l-auth-text-button>
                    </el-dropdown-item>
                    
                  </el-dropdown-menu>
                </el-dropdown>
                <l-auth-button type="primary" auth="cabinet_create_btn" @click="add_visible = true"> 新增培训项目</l-auth-button>
                <div class="l-simple-search-container">
                    <el-input placeholder="姓名/邮箱/手机号" v-model="search_data.keywords" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                    </el-input>
                </div>
            </div>
            <l-table :data="data" v-loading="loading" row-key="id">
                <el-table-column v-for="(item,index) in columns" :key="index" v-bind="{...item}" :label="item.label" show-overflow-tooltip>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="240" align="center">
                    <template slot-scope="{ row }">
                        <l-auth-text-button type="primary" auth="cabinet_info_btn" @click="showTrainList(row.id)"><i class="el-icon-warning-outline"></i>详情</l-auth-text-button>
                        <span class="l-action-separator">|</span>
                        <l-auth-text-button type="primary" auth="cabinet_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
                        <span class="l-action-separator">|</span>
                        <l-auth-text-button type="danger" auth="cabinet_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i> 删除</l-auth-text-button>
                    </template>
                </el-table-column>
            </l-table>
            <!--分页-->
            <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
            <!-- </div> -->
          <!-- </div> -->
        </div>

        <!--添加-->
        <l-dialog :visible.sync="add_visible" title="创建培训项目" width="1000px">
          <l-user-edit @on-success="onAddSucess" :visible.sync="add_visible" :org_id="org_id" />
        </l-dialog>

        <!--编辑-->
        <l-dialog :visible.sync="edit_visible" title="编辑培训项目" width="1000px">
          <l-user-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
        </l-dialog>

        <!--详情-->
        <l-dialog :visible.sync="train_list_visible" title="培训项目详情" width="1500px">
          <l-material-list :visible.sync="train_list_visible" :id="info_id" is-info />
        </l-dialog>
    </el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
import MaterialList from "./MaterialList.vue";
// import UserChangePwd from "@/views/user/ChangePwd";
import { emailFormat, phoneFormat } from "@/utils/Fuc";
import { STATES, STATE_NAMES } from "@/common/constants/resources";
import OrgList from "../public/OrgList.vue";
let columns = [
  {
    prop: "index",
    label: "序号",
    fixed: true,
    width: "60"
  },
  {
    prop: "active_state",
    label: "启用",
    fixed: true,
    width: "60"
  },
  {
    prop: "org_name",
    label: "所属组织架构",
    fixed: true,
    width: "120"
  },
  {
    prop: "name",
    label: "培训名称",
    fixed: true,
    Width: "120"
  },
  {
    prop: "site_code",
    label: "培训编码",
    fixed: true,
    Width: "60"
  },
  // {
  //   prop: "abbreviation",
  //   label: "场所名称缩写",
  //   fixed: true,
  //   Width: "120"
  // },
  {
    prop: "site_address",
    label: "培训地址",
    fixed: true,
    width: "120"
  },
  {
    prop: "site_charger",
    label: "培训负责人",
    fixed: true,
    width: "100"
  },
  {
    prop: "site_charger_tel",
    label: "负责人电话",
    fixed: true,
    width: "100"
  },
  // {
  //   prop: "site_contact",
  //   label: "场所联系人",
  //   fixed: true,
  //   width: "100"
  // },
  // {
  //   prop: "site_contact_tel",
  //   label: "联系人电话",
  //   fixed: true,
  //   width: "100"
  // },
  // {
  //   prop: "moduler_name",
  //   label: "所属模块",
  //   fixed: true,
  //   width: "100"
  // },
  {
    prop: "state_name",
    label: "状态",
    fixed: true,
    width: "60"
  },
];

export default {
  name: "cabinet-index",
  components: {
    [Edit.name]: Edit,
    [MaterialList.name]: MaterialList,
    // [UserChangePwd.name]: UserChangePwd,
    [OrgList.name]: OrgList
  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
    loading_export: false,
      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      train_list_visible: false, //是否显示培训分项列表
      info_id: 0,
      org_id:0,
      change_pwd_id: 0,
      STATE_NAMES: STATE_NAMES,
      STATES: STATES,
      //搜索
      search_visible: false,
      search_loading: true,
      site_tree: [],
      role_list: [],
      search_data: {
        keywords: "",
        name: "",
        mobile: "",
        email: "",
        site_id: undefined,
        role_id: "",
      },

      rel_search_data: {},
      show_more_search: false,
     
      re_fixed_list: ["index", "state"],
      fixed_list: ["index", "state"],
    };
  },

  computed: {
    columns() {
      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {
    fixed_list(val) {
      if (val.length > 3) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    emailFormat(num) {
      return emailFormat(num);
    },
    phoneFormat(num) {
      return phoneFormat(num);
    },

    //加载列表方法
    aftercheckOrg(org_id) {
     
      this.getList(org_id);
    },
    //获取数据
    getList(org_id) {
      this.org_id = org_id;
      this.loading = true;
      this.$_invoke("trainManage_getList", {
        page: this.page,
        page_size: this.page_size,
        org_id:org_id,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索数据
    getSearchData() {
      this.search_loading = true;
      this.$_invoke("adminUser_getSearchData")
        .then((ret) => {
          this.site_tree = ret.site_tree;
          this.role_list = ret.role_list;
        })
        .finally(() => {
          this.search_loading = false;
        });
    },

    //显示搜索
    showSearch() {
      this.search_visible = true;
      this.getSearchData();
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //显示培训详情(培训分项列表)
    showTrainList(id) {
        // console.log(id);
      this.info_id = id;
      this.$nextTick(() => {
        this.train_list_visible = true;
      });
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //修改状态
    changeState(row) {
      // console.log(row.id);
      this.change_state_loading.push(row.id);

      this.$_invoke(`adminUser_updState`, {
        id: row.id,
        state: row.state,
      })
        .then((ret) => {
          row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .catch((e) => {
           console.log(e);
        })
        .finally(() => { });
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList(this.org_id);
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList(this.org_id);
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.change_pwd_visible = true;
      });
    },

    //删除
    del(id) {
      this.$confirm(
        "确定删除该条记录吗" + "？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$_invoke(`trainManage_delete`, { id: id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getList();
            }
          });
        })
        .catch(() => { });
    },

    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
    
    //导出
    handleExport() {
      this.loading_export = true;
    
      this.$_invoke('trainManage_export_amount', {
            page: this.page,
            page_size: this.page_size,
            moduler: this.moduler,
            ...this.rel_search_data,
          })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.loading_export = false;
        });
    },
    command(e) {
      switch (e) {
        case 1: //台账
          this.placeAccount("trainManage_export_certlist");
          break;
        case 2: //其它
          this.placeAccount("trainManage_export_login");
          break;
        
      }
    },
    //导出
    placeAccount(url) {
      this.rel_search_data = this.search_data;
      this.loading_export = true;
      this.$_invoke(url, {
        type: this.search_data.type,
        ...this.rel_search_data
      })
        .then(ret => {
          window.open(ret);
        })
        .finally(() => {
          this.loading_export = false;
        });
    },
  },
};
  </script>